import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AntDModule } from 'src/app/modules/shared/antd.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LibsModule } from '../../libs/libs.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { QRCodeModule } from "angularx-qrcode";
import { SettingsComponent } from './settings/settings.component';
import { IntegrationModule } from "../integration/integration.module";
import { DeveloperRoutingModule } from './developer-routing.module';

@NgModule({
  declarations: [
    SettingsComponent
  ],
  imports: [
    CommonModule,
    AntDModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    LibsModule,
    NgxDaterangepickerMd,
    QRCodeModule,
    IntegrationModule,
    DeveloperRoutingModule
],
  exports: [
    SettingsComponent
  ]
})
export class DeveloperModule { }
